<template>
  <path
    d="M2.19217 3L2.19217 3.5L2.19217 3.5L2.19217 3ZM8 3L3 0.113249L3 5.88675L8 3ZM2.19217 2.5L-7.28522e-09 2.5L7.28525e-09 3.5L2.19217 3.5L2.19217 2.5ZM2.19217 3.5L3.5 3.5L3.5 2.5L2.19217 2.5L2.19217 3.5Z"
    fill="#C2C6CD"
  />
</template>
